import React from 'react';
import { useNavigate } from 'react-router-dom';

import { IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { GET_ROUTE_WAREHOUSE_DOCUMENT } from '../../../../../../core/constants';
import { FormRouteEnum } from '../../../../../../core/enums/common/route';
import SectionPaper from '../../../../../common/section_paper';
import { useSelector } from "react-redux";
import { getAllWarehousesState } from "../../../../../../features/inventory/get_all_warehouses";
import { getWarehouseName } from "../../../../../common/utils/warehouse_utils";

const WarehouseDocumentList = ({ documents }) => {
    const navigate = useNavigate();

    const getAllWarehouses = useSelector(getAllWarehousesState);

    if (!documents || documents.length === 0) {
        return null;
    }

    return (
        <SectionPaper title="Wygenerowane powiązane dokumenty">
            <TableContainer component={ Paper } variant="outlined">
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                            <TableCell>Typ</TableCell>
                            <TableCell align="left">Numer</TableCell>
                            <TableCell></TableCell>
                            <TableCell align="center" sx={ { width: 100 } }>Podgląd</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            documents?.map(document => {
                                const targetWarehouseObj = document?.targetWarehouseId
                                    ? getAllWarehouses?.data?.find(warehouse => warehouse?.internalId === document?.targetWarehouseId)
                                    : null;

                                const targetWarehouseName = targetWarehouseObj ? getWarehouseName(targetWarehouseObj) : '';

                                return (
                                    <TableRow
                                        key={ document?.documentId }
                                        hover
                                    >
                                        <TableCell sx={ { fontWeight: 500 } }>{ document?.documentType }</TableCell>
                                        <TableCell align="left">{ document?.documentNumber }</TableCell>
                                        <TableCell align="left">{ targetWarehouseName }</TableCell>
                                        <TableCell align="center">
                                            <Tooltip title="Podgląd dokumentu">
                                                <IconButton
                                                    size="small"
                                                    onClick={ () => navigate(GET_ROUTE_WAREHOUSE_DOCUMENT(document?.documentId), { state: { action: FormRouteEnum.VIEW } }) }
                                                >
                                                    <SearchIcon fontSize="small"/>
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </SectionPaper>
    );
};

export default WarehouseDocumentList;